import { Side } from '@floating-ui/react'
import { ReactNode } from 'react'

type Props = {
    children: ReactNode
    tooltipContent?: string | number | null
    showArrow?: boolean
    hidden?: boolean
    side?: Side
    noWrapText?: boolean
}

export const AstraTooltip = ({ children, showArrow = true, tooltipContent, hidden = false, noWrapText = false, side = 'top' }: Props) => {
    if (hidden || !tooltipContent) {
        return <>{children}</>
    }

    return (
        <div
            className="contents"
            data-tooltip-provider="hero-tooltip-wrapper"
            data-tooltip-placement={side}
            data-tooltip-no-wrap-text={noWrapText}
            data-tooltip-show-arrow={showArrow}
            data-tooltip={tooltipContent}
        >
            {children}
        </div>
    )
}
